module.exports = __webpack_public_path__ + "static/media/vehicle.2007a281.svg";